import { ParagraphWithRandomlyShakyWords } from "./ShakyText";
import { Box, Heading } from "react-bulma-components";
import styled from "styled-components";
import { useContext } from "react";
import StateContext from "../context/StateContext";
import { Warped } from "../effects/Cloudy";

const TextBoxBox = styled(Box)`
  background-color: ${(props) => props.theme.componentBackground};
  border: inset 0.7em ${(props) => props.theme.accentLight};
`;

function TextCard({ id, title, ...props }) {
  const [state] = useContext(StateContext);
  const textCard = (
    <TextBoxBox shadowless radiusless>
      <Heading size="1">{title}</Heading>
      <p>{props.text}</p>
      {/* <ParagraphWithRandomlyShakyWords
        probability={0.0}
        text={props.text}></ParagraphWithRandomlyShakyWords> */}
    </TextBoxBox>
  );
  if (state.watchedVideos < 5) {
    return textCard;
  } else {
    return <Warped id={"tcWarped_" + id}>{textCard}</Warped>;
  }
}

export default TextCard;
